module.exports = __webpack_public_path__ + "img/about-1.7264c324.png";